import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Apiservice } from './api.service';

export class Formulari {
  numeroFIR: string;
  dataEmissione: Date;
  codiceEER: string;
  dataCreazione: Date;
  unitaMisura: string
  quantita: number;
  classiPericolo?: string;
  destinazioneRifiuto: string;
  produttoreDenominazione: string;
  produttoreCodiceFiscale: string;
  destinatarioDenominazione: string;
  destinatarioCodiceFiscale: string;
  trasportatoreDenominazione: string;
  trasportatoreCodiceFiscale: string;
  statoFormulario: string;
  isAnnullato: boolean
  statoFisico: string;
}


@Injectable({
  providedIn: 'root'
})
export class RentriService {

  constructor(private Apiservice: Apiservice, private httpClient:HttpClient) {}

  getElencoFormulari(val:any='',queryString:string='') {
    
    
    const EndPoint=environment.BASE_API_URL+`RentriOld/getFormulariElenco?IdentificativoStruttura=${val}&${queryString}`;
    
    const HeaderOdata=this.Apiservice.httpOptionCall();   
    
    const response =  this.httpClient.get(EndPoint, HeaderOdata).toPromise();
    
    return response;
   
  }

  getElencoSiti(idSoggetto?): Promise<Object> {
    
   
    const EndPoint=environment.BASE_API_URL+"anagrafiche-rentri/GetElencoSiti?idSoggetto=" + idSoggetto;
    
    const HeaderOdata=this.Apiservice.httpOptionCall();   
    
    const response =  this.httpClient.get(EndPoint, HeaderOdata).toPromise();
    
    return response;
   
  }

  /********************VIVIFIR IN RENTRI********************/

  generaFir(idSoggetto:any,blocco,numeroFir){
    const EndPoint=environment.BASE_API_URL+`vidimazione-rentri/GeneraFir?IdSoggetto=${idSoggetto}&codice_blocco=${blocco}&numfir=${numeroFir}`;
    const headers = this.Apiservice.httpOptionCall();

    const response =  this.httpClient.post(EndPoint,'',headers).toPromise();

    return response;

  }
  

  validaViviFir(idSoggetto){

    const EndPoint=environment.BASE_API_URL+`vidimazione-rentri/ValidaViviFir?IdSoggetto=${idSoggetto}`;
    const headers = this.Apiservice.httpOptionCall();

    const response =  this.httpClient.post(EndPoint,'',headers).toPromise();

    return response;

  }

  /********************VIVIFIR IN RENTRI********************/

  loginRentri(user='demo',password='demo',licenza=''){
    const EndPoint=environment.BASE_API_URL+"RentriOld/LoginRentriApp";
    
    const headers = new HttpHeaders(); 
    headers.append('Content-Type', 'application/json');
    const body={
      
      "username": "demo",
      "password": "demo",
      "codiceFiscaleAzienda": "05669600636",
      "clientId": "116BBA6D-E40F-4080-9689-6EAD23E67AA2@RENTRI",
      "clientSecret": "289Mx*hd6B"
    }  
    
    const response =  this.httpClient.post(EndPoint,body,{headers}).toPromise();
   
    return response;

  }

  loginRentriSoggetto(id){

    //LoginRentriBySoggetto?IdSoggetto=1

    const EndPoint=environment.BASE_API_URL+"RentriOld/LoginRentriBySoggetto?IdSoggetto="+id;
    const headers = this.Apiservice.httpOptionCall();
    console.log(headers)
   /* const HeaderOdata=this.Apiservice.httpOptionCall();
    headers.append('Content-Type', 'application/json');*/

    const response =  this.httpClient.post(EndPoint,'',headers).toPromise();
   
    return response;
  }

  loginRentriSede(id){

    //LoginRentriBySoggetto?IdSoggetto=1

    const EndPoint=environment.BASE_API_URL+"RentriOld/LoginRentriBySede?IdSede="+id;
    const headers = this.Apiservice.httpOptionCall();
   
   /* const HeaderOdata=this.Apiservice.httpOptionCall();
    headers.append('Content-Type', 'application/json');*/

    const response =  this.httpClient.post(EndPoint,'',headers).toPromise();
   
    return response;
  }

  getInfoRentri(idSoggetto){
    

    const EndPoint=environment.BASE_API_URL+"RentriOld/GetInfoApiRentri?IdSoggetto="+idSoggetto;
    const headers = this.Apiservice.httpOptionCall();
   
   /* const HeaderOdata=this.Apiservice.httpOptionCall();
    headers.append('Content-Type', 'application/json');*/

    const response =  this.httpClient.post(EndPoint,'',headers).toPromise();
   
    return response;
  }

  getInfoAzienda(): Promise<Object> {
    
   
    const EndPoint=environment.BASE_API_URL+"RentriOld/getSoggettiElenco";
    
    const HeaderOdata=this.Apiservice.httpOptionCall();   
    
    const response =  this.httpClient.get(EndPoint, HeaderOdata).toPromise();
    
    return response;
   
  }

  downloadxFir(idFIR){

    const EndPoint=environment.BASE_API_URL+`RentriOld/getFormularioXFir?numeroFir=${idFIR}` ;
    
    const HeaderOdata=this.Apiservice.httpOptionCall();   
    
    const response =  this.httpClient.get(EndPoint, HeaderOdata).toPromise();
    if(response){

      return response;

    }
    

  }

  downloadPDF(idFIR){

    const EndPoint=environment.BASE_API_URL+`RentriOld/getFormularioPdf?numeroFir=${idFIR}` ;
    
    const HeaderOdata=this.Apiservice.httpOptionCall();   
    
    const response =  this.httpClient.get(EndPoint, HeaderOdata).toPromise();
    if(response){

      return response;

    }
    

  }

  getDettaglioFormulario(idFIR){

    const EndPoint=environment.BASE_API_URL+`RentriOld/getFormulario?numeroFir=${idFIR}` ;
    
    const HeaderOdata=this.Apiservice.httpOptionCall();   
    
    const response =  this.httpClient.get(EndPoint, HeaderOdata).toPromise();
    if(response){

      return response;

    }
    
  }

  statoFormuario(idFIR){
    const EndPoint=environment.BASE_API_URL+`RentriOld/getFormulario?numeroFir=${idFIR}` ;
    
    const HeaderOdata=this.Apiservice.httpOptionCall();   
    
    const response =  this.httpClient.get(EndPoint, HeaderOdata).toPromise();
    if(response){

      return response;

    }
  }
  

  /***Inserisci FORMULARIO***/

  salvaFormulario(datiParse){

    const EndPoint = environment.BASE_API_URL + `RentriOld/inviaFormulario`;
    const HeaderOdata = this.Apiservice.httpOptionCall();

    const response = this.httpClient.post(EndPoint,datiParse,HeaderOdata).toPromise();
    return response;

  }


  /*** Aggiungi dati Trasporto ***/

  aggiungiDatiTrasporto(jsonDatiTrasportpPartenza,numeroFir,idTrasportatore){

    const EndPoint = environment.BASE_API_URL + `RentriOld/aggiungiDatiTrasporto?numeroFir=${numeroFir}&idTrasportatore=${idTrasportatore}`;

    const HeaderOdata = this.Apiservice.httpOptionCall();

    const response = this.httpClient.post(EndPoint,jsonDatiTrasportpPartenza,HeaderOdata).toPromise();
    return response;
  }

  /*** Aggiu8ngi dati quantità ***/

  aggiungiDatiQuantita(jsonDatiAccettazione,numeroFir){
    const EndPoint = environment.BASE_API_URL + `RentriOld/aggiungiDatiQuantita?numeroFir=${numeroFir}`;

    const HeaderOdata = this.Apiservice.httpOptionCall();

    const response = this.httpClient.post(EndPoint,jsonDatiAccettazione,HeaderOdata).toPromise();
    return response;

  }

  /*** Aggiu8ngi dati Accettazione ***/

  aggiungiDatiAccettazione(jsonDatiAccettazione,numeroFir){
    const EndPoint = environment.BASE_API_URL + `RentriOld/aggiungiDatiAccettazione?numeroFir=${numeroFir}`;

    const HeaderOdata = this.Apiservice.httpOptionCall();

    const response = this.httpClient.post(EndPoint,jsonDatiAccettazione,HeaderOdata).toPromise();
    return response;

  }


  /*** Modifica Formulario ***/
  salvaFormularioModificato(datiParse, numeroFIR){

    const EndPoint = environment.BASE_API_URL + `RentriOld/modificaFormulario?numeroFir=${numeroFIR}`;
    const HeaderOdata = this.Apiservice.httpOptionCall();

    const response = this.httpClient.put(EndPoint,datiParse,HeaderOdata).toPromise();
    return response;

  }


  /***Firma Formulario***/

  firmaFormulario(identificativo,tipoFirma,numFir){
    const EndPoint = environment.BASE_API_URL + `RentriOld/firmaFormulario?numeroFir=${numFir}&tipoFirma=${tipoFirma}&idTrasportatore=${identificativo}`;
    const HeaderOdata = this.Apiservice.httpOptionCall();

    const response = this.httpClient.post(EndPoint,'',HeaderOdata).toPromise();
    return response;

  }

  /***Registro Movimenti***/
  
  getRegistri(idSoggetto?,num_iscr_sito?){

    const EndPoint=environment.BASE_API_URL+`RentriOld/GetElencoRegistri?IdSoggetto=${idSoggetto}&num_iscr_sito=${num_iscr_sito}` ;
    
    const HeaderOdata=this.Apiservice.httpOptionCall();   
    
    const response =  this.httpClient.get(EndPoint, HeaderOdata).toPromise();
    if(response){

      return response;

    }

  }

  getMovimenti(idRegistro){

    const EndPoint=environment.BASE_API_URL+`RentriOld/getMovimentiRegistroElenco?IdentificativoRegistro=${idRegistro}` ;
    
    const HeaderOdata=this.Apiservice.httpOptionCall();   
    
    const response =  this.httpClient.get(EndPoint, HeaderOdata).toPromise();
    if(response){

      return response;

    }
  }

 
  
}
